import { useState } from "react";
import { Link } from "react-router-dom";
import { Meteors } from "@stianlarsen/meteors";
import "./FeaturedProjects.css";
import projects from "../../data/projects.js";
import ProjectModal from "../ProjectModal/ProjectModal";
import { logFeaturedProjectModalOpen } from "../../supabaseTracker";

// First 3 projects are featured (P&L + QuickStart + R&B TEAUSA)
const featuredProjects = projects.slice(0, 3);

export default function FeaturedProjects() {
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(0);

  const openProjectModal = (index) => {
    const project = featuredProjects[index];
    setSelectedProjectIndex(index);
    setShowProjectModal(true);
    if (project) {
      logFeaturedProjectModalOpen(project.slug || project.id || project.title, project.title);
    }
  };

  return (
    <>
      <section id="featured-projects" className="section featured-projects" style={{ position: "relative" }}>
        <div id="featured-projects-container" className="featured-projects-wrapper" style={{ position: "relative" }}>
          <h2 className="section__title featured-projects__title">Featured Projects</h2>
          <Meteors
            speed={0.1}
            size={20}
            amount={2}
            colorLightmode="#2978b5"
            colorDarkmode="white"
            fallingSide="left"
          />

          <div className="featured-cards">
            {featuredProjects.map((project, index) => (
              <div
                key={project.title}
                className={`featured-card featured-card--${
                  project.featuredLayout || "desktop"
                }`}
                onClick={() => openProjectModal(index)}
                style={{ cursor: 'pointer' }}
              >
                <div
                  className="featured-card__image-wrapper"
                >
                  <img
                    src={project.featuredImage || project.images?.[0]}
                    alt={project.title}
                    className="featured-card__image"
                  />
                </div>
                <div className="featured-card__content">
                  <h3 className="featured-card__title">{project.title}</h3>
                  <p className="featured-card__body">
                    {project.description.length > 110
                      ? `${project.description.substring(0, 110)}...`
                      : project.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="featured-projects__button-container">
            <Link
              to="/projects"
              className="featured-projects__button"
            >
              View All Projects
            </Link>
          </div>
        </div>
      </section>

      {showProjectModal && (
        <ProjectModal
          projects={projects}
          initialIndex={selectedProjectIndex}
          onClose={() => setShowProjectModal(false)}
        />
      )}
    </>
  );
}
